import { IAudio } from '@/shared/components/types.ts';
import { MaybeNull } from '@/shared/types';
import { Capacitor } from '@capacitor/core';
import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useVoiceoverStore = defineStore('voiceoverStore', () => {
  // permission to reproduce the audio dubbing of the verse
  const voiceoverEnabled = ref(
    Capacitor.isNativePlatform()
      ? (localStorage.getItem('voiceover-enabled') === null || JSON.parse(localStorage.getItem('voiceover-enabled')!))
      : false,
  );

  const voiceover = ref<MaybeNull<IAudio>>(null);

  const voiceovers = ref<Set<string>>(new Set());

  watch(() => voiceoverEnabled.value, (value: boolean) => {
    if (value) {
      localStorage.setItem('voiceover-enabled', 'true');
    } else {
      localStorage.setItem('voiceover-enabled', 'false');
    }
  });

  return {
    voiceoverEnabled,
    voiceovers,
    voiceover,
  };
});
